import { jsx as _jsx } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { AlertBanner } from "@faire/web--source/ui/AlertBanner";
import * as React from "react";
import { getBrand } from "@faire/retailer/serialized-data/getBrand";
import { useUserStore } from "@faire/retailer/stores/domain/UserStore";
export var FaireDirectBrandPreviewBanner = function() {
    var _getBrand;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var logOut = useUserStore([
        "logOut"
    ]).logOut;
    return /*#__PURE__*/ _jsx(AlertBanner, {
        color: Decorative.shade.orange,
        textColor: Core.text.inverse,
        message: strictLocalize({
            id: "UI+ExT",
            defaultMessage: [
                {
                    type: 0,
                    value: "Viewing this page as "
                },
                {
                    type: 1,
                    value: "brand"
                },
                {
                    type: 0,
                    value: "."
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            brand: (_getBrand = getBrand()) === null || _getBrand === void 0 ? void 0 : _getBrand.name
        })),
        alertAction: {
            text: strictLocalize({
                id: "F62y+K",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign Out"
                    }
                ]
            }),
            action: {
                onClick: function() {
                    logOut();
                }
            }
        }
    });
};
